import { ValueOf } from "@claroty/utilities/types/ValueOf";
import autoBind from "auto-bind";
import { PRE_AUTH_SERVER_ERROR_CODES } from "../const/preAuthConsts";
import { MFAMethod } from "../components/Pages/Settings/Admin/LoginManagement/LoginTypes";
import BaseAPI from "./BaseAPI";
import * as RestClient from "./RestClient/RestClient";

type LoginResponse = {
    requires_mfa: boolean;
    password_days_left?: number;
    mfa_method?: MFAMethod;
    mfa_email?: string;
    host?: string;
    sig_request?: string;
};

type PreConfirmCheckResponse = {
    can_confirm: boolean;
    can_login: boolean;
    error_code?: ValueOf<typeof PRE_AUTH_SERVER_ERROR_CODES>;
};

class PreAuthAPI extends BaseAPI {
    constructor() {
        super();
        autoBind(this);
    }

    loginUser = ({
        username = undefined,
        password = undefined,
        emailMfaCode = undefined,
        trustThisComputer = false,
        duoMfaResponse = undefined,
        nextPath = undefined,
    } = {}) =>
        RestClient.post<LoginResponse>("login-user", {
            username,
            password,
            email_mfa_code: emailMfaCode,
            duo_mfa_response: duoMfaResponse,
            trust_this_computer: trustThisComputer,
            next_path: nextPath,
        });
    restoreLogin = () => RestClient.get<unknown>("api/v1/initial-configuration");

    preConfirmCheck = (username, token) =>
        RestClient.post<PreConfirmCheckResponse>("api/v1/user/pre-confirm-check", { username, token });
    resetPassword = (username, token, new_password) =>
        RestClient.post<undefined>("change-password", { username, token, new_password });
    activateUser = (username, token, password) =>
        RestClient.post<undefined>("api/v1/user/activate", { username, token, password });
    sendPasswordResetMail = email => RestClient.post<undefined>("forgot-password", { email: email });
    changePassword = (userName, oldPassword, newPassword) =>
        RestClient.post<undefined>("change-password", {
            username: userName,
            old_password: oldPassword,
            new_password: newPassword,
        });

    scheduledReportsUnsubscribe = (token, resubscribe = undefined) =>
        RestClient.post<undefined>("api-internal/v1/scheduled-exports/unsubscribe", { token, resubscribe });
}

export default PreAuthAPI;
